import Tags from './tags'
import Uploads from './uploads'
import Accounts from './accounts'
import { BadDataReviewSubmissions } from './review-bad-data/BadDataReviewSubmissions'
import { AuthorizersPage } from './authorizers'
import { SystemUsersPage } from './system-users'

export default {
  Tags,
  Uploads,
  Accounts,
  ReviewBadData: BadDataReviewSubmissions,
  Authorizers: AuthorizersPage,
  SystemUsers: SystemUsersPage,
}
